import { render, staticRenderFns } from "./GoodsAttrbuit.vue?vue&type=template&id=73236be4&scoped=true"
import script from "./GoodsAttrbuit.vue?vue&type=script&lang=js"
export * from "./GoodsAttrbuit.vue?vue&type=script&lang=js"
import style0 from "./GoodsAttrbuit.vue?vue&type=style&index=0&id=73236be4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73236be4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73236be4')) {
      api.createRecord('73236be4', component.options)
    } else {
      api.reload('73236be4', component.options)
    }
    module.hot.accept("./GoodsAttrbuit.vue?vue&type=template&id=73236be4&scoped=true", function () {
      api.rerender('73236be4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/creatStore/modules/GoodsAttrbuit.vue"
export default component.exports